// extracted by mini-css-extract-plugin
export default {"root":"addTask_root__wd1m8"};